import GatewayCard from './gatewayCard.component';

export default GatewayCard;
